var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1898.274,
    height: 296.31,
    viewBox: "0 0 1898.274 296.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171821",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3472",
    "data-name": "Path 3472",
    d: "M5849.389,750.427s88.45-65.821,136.139-25.55,40.608,50.869,76.472,8.478,66.6-127.171,112.166-56.167,24.374,121.045,72.063,73.24,56.167-140,94.319-94.435,57.227,151.546,79.482,86.9,44.51-121.873,64.646-65.705,6.358,165.323,48.749,110.215,39.211-84.548,68.884-36.975,68.884,28.5,81.6-17.072,29.674-82.661,55.108-24.375,34.972,104.089,60.406,41.447,34.972-110.331,71-55.224,51.929,86.9,80.542,27.554,50.869,144.127,86.9,109.155,31.793-40.271,55.107-11.657,47.03-30.79,79.4-22.406,57.637,49.959,82.908,9.2,35.053-70.922,60.325-38.314,35.054,66.031,62.771,23.641,34.239-138.584,80.705-59.51,35.053-86.411,82.335-75,33.423,161.41,69.292,105.161,45.651-126.356,79.075-50.542,57.879,37.5,57.879,37.5V940H5849.389Z",
    transform: "translate(-5849.389 -643.688)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGraph);
export default __webpack_public_path__ + "static/media/NoGraph.40dbbb64b65e045d9d4b8692a5f29373.svg";
export { ForwardRef as ReactComponent };